import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import ContentLoading from 'Components/ComponentLibrary/Molecules/ContentLoading';
import MessageListPicker from '../../Components/MessageListPicker';
import { useCommentLayoutContext } from '../../CommentLayoutProvider';

const Container = () => {
  const { threadCollection, threadCollectionError } = useCommentLayoutContext();

  return (
    <DataContainer
      component={MessageListPicker}
      loading={!threadCollection}
      loadingError={threadCollectionError}
      skeleton={ContentLoading}
    />
  );
};

Container.defaultProps = {
};

Container.propTypes = {
};

export default Container;
